import FormContainer from '@components/FormContainer';
import { Article } from '@components/InputRichText';
import JobOfferMissionForm from '@modules/JobOffers/JobOfferDetail/components/JobOfferMissionForm';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

const JobOfferMissions = ({ pro, jobOffer, onSubmit, loading }: { pro: any, jobOffer: any, onSubmit?: () => Promise<void>, loading?: boolean }) => {
    const [formState, setFormState] = useState<'view' | 'edit'>('view');
    const { getValues } = useFormContext();

    const handleCancel = () => {
        setFormState('view');
    };

    const handleSubmit = async () => {
        await onSubmit?.();
        setFormState('view');
    }
    return (
        <FormContainer
            formTitle="Missions"
            formState={formState}
            setFormState={setFormState}
            loading={loading}
            onCancel={handleCancel}
            onSubmit={handleSubmit}
        >
            {formState === 'view' ? (
                <Article
                    sx={{
                        fontSize: '16px',
                        lineHeight: '24px',
                        fontWeight: 400
                    }}
                    dangerouslySetInnerHTML={{ __html: getValues('description.missions') ?? '' }}
                />
            ) : (
                <JobOfferMissionForm />
            )}
        </FormContainer>
    );
};

export default JobOfferMissions;
